import { apiClient } from './client';

export async function dismissOffer(offerId: string): Promise<{ success: boolean }> {
  return apiClient.post('/dismissed-offers', { offerId });
}

export async function undismissOffer(offerId: string): Promise<{ success: boolean }> {
  return apiClient.delete(`/dismissed-offers/${offerId}`);
}
